module.exports = __webpack_public_path__ + "img/marker_four_cyan3.fa6d6c3f.png";